import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { LoginContainer, LoginGrid, LoginTitle, LoginWrapper } from '~src/outer_modules/login/login.sc';

import UseOtpForm from './components/UseOtpForm';

const Otp: FC = () => {
  const { t } = useTranslation();

  return (
    <LoginContainer $full>
      <LoginGrid>
        <LoginWrapper>
          <LoginTitle data-translation="x.otp.title">{t('x.otp.title')}</LoginTitle>
          <UseOtpForm />
        </LoginWrapper>
      </LoginGrid>
    </LoginContainer>
  );
};

export default Otp;
